/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Paging from '../../component/Inc/Paging';
import PopSpecialMember from './_PopSpecialMember';

function SpeacialMember() {
  const [modalSpecialMember, setModalSpecialMember] = useState(false);
  return (
    <main className="com_container p_evaluation_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_22">특별회원 리스트</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalSpecialMember(true)} className="com_btn orange s btn_plus">
              특별회원 추가
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="70" />
                <col width="100" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="120" />
                <col width="120" />
                <col width="120" />
                <col width="auto" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>선택</th>
                  <th>학생명</th>
                  <th>전화번호</th>
                  <th>성별 / 나이</th>
                  <th>지역</th>
                  <th>학교</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>사유</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>
                      <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                      <label htmlFor={`chk${idx}`}></label>
                    </td>
                    <td>가길동107</td>
                    <td>010-1234-4678</td>
                    <td>남 / 2009</td>
                    <td>서울 / 강남구</td>
                    <td>서울고</td>
                    <td>
                      <button className="btn_link">김교사103</button>
                    </td>
                    <td>
                      <button className="btn_link">김담임475</button>
                    </td>
                    <td>이사님 친척분 자제입니다.</td>
                    <td>
                      <button className="btn_link blue">보기</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <div className="com_btn_wrap left">
                <button className="com_btn gray xs">선택항목 삭제</button>
              </div>
              <Paging />
            </div>
          </section>
        </section>
      </div>
      <PopSpecialMember open={modalSpecialMember} close={() => setModalSpecialMember(false)} />
    </main>
  );
}

export default SpeacialMember;
